<!-- <div class="flex justify-center h-full align-center">

</div> -->

<div class="h-screen bg-[#F8F9FA] flex justify-center items-center">
  <div
    class="bg-white border border-[#E4E9EF] shadow-md rounded-[20px] p-10 w-full mx-5 sm:w-fit"
  >
    <div class="flex flex-col items-center">
      <img
        class="w-[105px] mb-3"
        src="assets/img/logo-bci-negro-transparente.png"
        alt="BCI Loading"
      />
      <h2 class="font-medium text-4xl mb-2">Bienvenido</h2>
      <h3 class="font-normal mb-6">Ingresa a tu portal de ciberseguridad</h3>
    </div>
    <div>
      <form
        class="flex flex-col w-full sm:w-[405px]"
        [formGroup]="loginForm"
        (ngSubmit)="handleLogin()"
      >
        <div class="my-4">
          <app-input-custom
            icon="assets/icons/usernameLoginIcon.svg"
            label="Usuario"
            formControlName="username"
            [hasError]="username?.errors?.['required'] && submitted"
          />
          @if (submitted && username?.errors?.['required']) {
          <p class="text-red-600 text-sm font-normal">
            El usuario es obligatorio.
          </p>
          }
        </div>
        <div class="mb-5">
          <app-input-custom
            icon="assets/icons/passwordLoginIcon.svg"
            label="Contraseña"
            formControlName="password"
            type="password"
            [hasError]="password?.errors?.['required'] && submitted"
          />
          @if (submitted && password?.errors?.['required']) {
          <p class="text-red-600 text-sm font-normal">
            La contraseña es obligatoria.
          </p>
          }
        </div>

        <app-button-primary
          label="INGRESAR"
          type="submit"
          class="mb-10"
          buttonClass="h-[52px]!"
        />
        <div class="text-sm text-[#B7B7B7] text-center">
          Versión {{ versionFromPkgJson }}
        </div>
      </form>
    </div>
  </div>
</div>
